/**
 * YouVisit Live VR Player
 *
 * Manages the 360 Video Player on Desktop
 *
 * Author: Dan && Akil
 */
import PanoPlayer from '../panorama/PanoPlayer'
import * as THREE from 'three'
import { THREEx } from './videoTexture'
import $ from 'jquery'

var EASY_PROJECTION = 'easy'

/**
 * Class VRVideoPlayer does the actual rendering work
 */
var VRVideoPlayer = function(options) {
    this.options = options || {}
    this.videoid = options.videoid
    this.domId = options.domId
    this.source = options.source || ''
    this.autoplay = options.autoplay || false
    this._autorotate = options.autorotate || false
    this._startFov = options.startFov || '100'
    this._autorotateSpeed = options.autorotateSpeed || 0.2
    this._rotateFrequency = options.autorotateFrequency || 0.1
    this._rotateLeft = options.rotateLeft || false
    this._rotateRight = options.rotateRight || false
    this.accelerometerControls = options.accelerometerControls || false

    this.projection = options.projection || false

    this._onReadyCb = options.onReadyCb || null
    this._onErrorCb = options.onErrorCb || null
    this._onPlayCb = options.onPlayCb || null
    this._onPauseCb = options.onPauseCb || null
    this._onProgressCb = options.onProgressCb || null
    this._onFinishCb = options.onFinishCb || null
    this._onDragEndCb = options.onDragEndCb || null
    this._onDragStartCb = options.onDragStartCb || null

    this._time = 0
    this._video = $('<video/>', {
        crossOrigin: 'anonymous',
        src: this.source,
    })[0]
    $(this._video).append('<source/>')
    this.setup360Render()
    this.hasContentToRender = this.hasContentToRender.bind(this)
    this._onVideoPlay = this._onVideoPlay.bind(this)
    this._onVideoPause = this._onVideoPause.bind(this)
    this._onVideoError = this._onVideoError.bind(this)
    this._onVideoReady = this._onVideoReady.bind(this)
    this._onVideoProgress = this._onVideoProgress.bind(this)
    this._onVideoFinish = this._onVideoFinish.bind(this)
    this._onDragEnd = this._onDragEnd.bind(this)
    this._onDragStart = this._onDragStart.bind(this)
}

VRVideoPlayer.prototype.start = function() {
    this.waitForState()
    return true
}

VRVideoPlayer.prototype.pause = function() {
    return this.htmlPlayer.pause()
}

VRVideoPlayer.prototype.play = function() {
    //ensure we have a panoplayer
    this.setupPanoPlayer()
    return this.htmlPlayer.play()
}

VRVideoPlayer.prototype.seek = function(seconds) {
    return (this.htmlPlayer.currentTime = seconds)
}

VRVideoPlayer.prototype.getCurrentTime = function() {
    return this.htmlPlayer.currentTime
}

VRVideoPlayer.prototype.setVolume = function(volume) {
    return (this.htmlPlayer.volume = volume)
}

VRVideoPlayer.prototype.getVolume = function() {
    return this.htmlPlayer.volume
}

VRVideoPlayer.prototype.getDuration = function() {
    return this.htmlPlayer.duration
}

VRVideoPlayer.prototype.getLoadedProgress = function() {
    try {
        return this.htmlPlayer.buffered.end(0)
    } catch (e) {}
    return 0
}

VRVideoPlayer.prototype.isPaused = function() {
    return this.htmlPlayer.paused
}

VRVideoPlayer.prototype.setSource = function(source) {
    var sourceObj = $(this._video).find('source')

    this.source = source
    sourceObj.attr('type', 'video/mp4')
    sourceObj.attr('crossOrigin', 'anonymous')
    sourceObj.attr('src', this.source)
}

VRVideoPlayer.prototype.playVideo = function(source, paused, time) {
    this.htmlPlayer.pause()

    this.source = source
    this.htmlPlayer.crossOrigin = 'anonymous'
    this.htmlPlayer.src = source

    if (time !== undefined) {
        // For IE 10 setting the currentTime is causing it to crash.
        // Wrapping around try/catch block
        try {
            this.htmlPlayer.currentTime = time
        } catch (err) {}
    }
    if (paused) {
        this.htmlPlayer.pause()
    } else {
        this.htmlPlayer.play()
    }
}

/**
 * Configure and create (render)
 * @return boolean if render was setup successfully.
 */
VRVideoPlayer.prototype.setup360Render = function() {
    if (this._video) {
        this._texture = new THREEx.VideoTexture(this._video)
        this._texture.generateMipmaps = false
        this._texture.minFilter = THREE.LinearFilter
        this._texture.magFilter = THREE.LinearFilter
        this._texture.format = THREE.RGBFormat
        this._texture.needsUpdate = true
    }
    return true
}

/**
 * To Ensure that our canvas is properly setup we should setup the PanoPlayer at the last minute.
 * @return boolean
 */
VRVideoPlayer.prototype.setupPanoPlayer = function() {
    if (typeof this._panoPlayer !== 'undefined') {
        return true
    }
    var containerid = 'ThreeSixtyMediaPanoPlayer-' + this.videoid,
        containerclass = 'alt-media-player three-sixty-player',
        scope = this

    var playerContainer = $('<div />')
            .addClass(containerclass)
            .attr('id', containerid),
        options = {
            type: this.projection,
            texture: this._texture,
            path: '',
            selector: containerid,
            autoRotate: this._autorotate,
            autoRotateSpeed: this._autorotateSpeed,
            showHint: false,
            showRotate: false,
            showFullscreen: false,
            startLon: scope.longitude,
            startLat: scope.latitude,
            startFov: this._startFov,
            hintTimeout: 3000,
            businessCard: null,
            hasEasy: this.projection == EASY_PROJECTION,
            autoResize: true,
            accelerometerControls: this.accelerometerControls,
        }
    $('#' + this.domId).append(playerContainer)
    this._panoPlayer = new PanoPlayer(options)
    this._panoPlayer.embed()
    this._panoPlayer.on('dragend', this._onDragEnd)
    this._panoPlayer.on('dragstart', this._onDragStart)
    return true
}

VRVideoPlayer.prototype.destroy = function() {
    if (this._video) {
        this._video.pause()
        //force stop loading video
        this._video.src = ''
        try {
            this._video.load()
        } catch (err) {}
        try {
            this._video.remove()
        } catch (err) {}
        delete this._video
        this._video = null
    }
    if (this._texture) {
        this._texture.dispose()
        this._texture = null
    }
    if (this._panoPlayer) {
        this._panoPlayer.destroy()
        this._panoPlayer = null
    }

    if (this._lastAnimationReq) {
        var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
        cancelAnimationFrame(this._lastAnimationReq)
    }

    this.htmlPlayer.removeEventListener('play', this._onVideoPlay)
    this.htmlPlayer.removeEventListener('pause', this._onVideoPause)
    this.htmlPlayer.removeEventListener('error', this._onVideoError)
    this.htmlPlayer.removeEventListener('loadeddata', this._onVideoReady)
    this.htmlPlayer.removeEventListener('progress', this._onVideoProgress)
    this.htmlPlayer.removeEventListener('ended', this._onVideoFinish)

    this._onReadyCb = null
    this._onErrorCb = null
    this._onPlayCb = null
    this._onPauseCb = null
    this._onProgressCb = null
    this._onFinishCb = null

    // we need to free texture image resources to prevent memory leaking
    this._destroyed = true
}

/**
 * We neeed to update the view with new frame
 */
VRVideoPlayer.prototype.hasContentToRender = function() {
    var scope = this
    //ensure we update texture
    this._lastAnimationReq = requestAnimationFrame(this.hasContentToRender)

    if (this._video == null) return false
    if (this._destroyed) return
    var scope = this
    if (this._video !== false && typeof this._video != 'undefined' && this._video.isPaused != false) {
        this._texture.needsUpdate = true
        this._panoPlayer.panorama.setNeedsRefresh()
        return true
    }
    return false
}

VRVideoPlayer.prototype._onDragEnd = function(e) {
    if (this._onDragEndCb !== null) this._onDragEndCb(e)
}

VRVideoPlayer.prototype._onDragStart = function(e) {
    if (this._onDragStartCb !== null) this._onDragStartCb(e)
}

/**
 * Video is Ready to play
 */
VRVideoPlayer.prototype._onVideoReady = function() {
    if (this._onReadyCb !== null) {
        this._onReadyCb.call(this)
    }
}

/**
 * Video progress
 */
VRVideoPlayer.prototype._onVideoProgress = function() {
    if (this._onProgressCb !== null) {
        this._onProgressCb()
    }
}

VRVideoPlayer.prototype._onVideoPause = function() {
    if (this._lastAnimationReq) {
        //we need to cancel the animation frame since the video is paused
        var cancelAnimationFrame =
            window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelRequestAnimationFrame
        cancelAnimationFrame(this._lastAnimationReq)
        this._lastAnimationReq = false
    }
    if (this._onPauseCb !== null) {
        this._onPauseCb()
    }
}

VRVideoPlayer.prototype._onVideoFinish = function() {
    if (this._onFinishCb !== null) {
        this._onFinishCb()
    }
}

/**
 * Video has started to play
 */
VRVideoPlayer.prototype._onVideoPlay = function() {
    var scope = this
    //ensure we update texture
    this._lastAnimationReq = requestAnimationFrame(this.hasContentToRender)
    $('#status').hide()
    if (this._onPlayCb !== null) {
        this._onPlayCb()
    }
}

VRVideoPlayer.prototype.waitForState = function() {
    this.setupVideoPlayer()
    this._video.load()
}

/**
 * Video error occurred
 */
VRVideoPlayer.prototype._onVideoError = function() {
    if (this._onErrorCb !== null) {
        this._onErrorCb()
    }
}

/**
 * Attempt to Restart Video PLayer
 */
VRVideoPlayer.prototype.restartPlayer = function() {
    try {
        console.log('restartPlayer..')
        if (typeof this.htmlPlayer != 'undefined') {
            this.htmlPlayer.load()
            this.htmlPlayer.play()
        }
        if (typeof this.dashPlayer != 'undefined') {
            this.dashPlayer.unload()
            this.dashPlayer.load(window.YouVisit.VR.dashConfig.source)
            this.dashPlayer.play()
        }
    } catch (e) {}
}

/**
 * Get Stats String
 * @return string stats for displaying to front end
 */
VRVideoPlayer.prototype.getStats = function() {
    if (typeof this.dashPlayer != 'undefined') {
        var videoData = this.dashPlayer.getPlaybackVideoData()
        return (
            'id: ' +
            videoData.id +
            '<br/>' +
            'bitrate: ' +
            videoData.bitrate +
            '<br/>' +
            'width: ' +
            videoData.width +
            '<br/>' +
            'height: ' +
            videoData.height +
            '<br/>' +
            'droppedFrames: ' +
            this.dashPlayer.getDroppedFrames() +
            '<br/>' +
            'buffer length: ' +
            this.dashPlayer.getVideoBufferLength() +
            '<br/>' +
            'stalled time: ' +
            this.dashPlayer.getTotalStalledTime()
        )
    }
    return ''
}

/**
 * Setup Video Player
 * Waits for window.YouVisit.VR.status to be active
 */
VRVideoPlayer.prototype.setupVideoPlayer = function() {
    var scope = this,
        videoElement = this._video

    videoElement.autoplay = this.autoplay
    videoElement.crossOrigin = 'anonymous'
    videoElement.setAttribute('playsinline', '')
    this.setSource(this.source)
    videoElement.addEventListener('play', scope._onVideoPlay)
    videoElement.addEventListener('pause', scope._onVideoPause)
    videoElement.addEventListener('error', scope._onVideoError)
    videoElement.addEventListener('loadeddata', scope._onVideoReady)
    videoElement.addEventListener('progress', scope._onVideoProgress)
    videoElement.addEventListener('timeupdate', scope._onVideoProgress)
    videoElement.addEventListener('ended', scope._onVideoFinish)

    this.htmlPlayer = videoElement
}

VRVideoPlayer.prototype.enableAccelerometerControls = function(enabled) {
    this.accelerometerControls = enabled
}

export default VRVideoPlayer
